import "./styles.scss";
import wakaLogo from "../../assets/img/v5-waka-payroll.png";

const Icon = ({ name, size = 22 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  };

  const paths = {
    arrow: (
      <>
        <path d="M5 12h14" />
        <path d="M13 6l6 6-6 6" />
      </>
    ),
    check: <path d="m5 12 4 4L19 6" />,
    payroll: (
      <>
        <path d="M5 4h14v16H5Z" />
        <path d="M8 8h8M8 12h8M8 16h5" />
        <path d="M17 15.5c0 .8-.8 1.5-1.8 1.5S13.4 16.5 13 16" />
      </>
    ),
    clock: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l4 2" />
      </>
    ),
    user: (
      <>
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21a8 8 0 0 1 16 0" />
      </>
    ),
    approval: (
      <>
        <path d="M8 12.5 11 15l5-6" />
        <rect x="3" y="4" width="18" height="16" rx="3" />
      </>
    ),
    report: (
      <>
        <path d="M4 19V5a2 2 0 0 1 2-2h9l5 5v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z" />
        <path d="M14 3v6h6" />
        <path d="M8 16v-3M12 16v-6M16 16v-4" />
      </>
    ),
    offline: (
      <>
        <path d="M8.5 17H8a4 4 0 0 1-.9-7.9A6 6 0 0 1 18.5 11" />
        <path d="m3 3 18 18" />
        <path d="M12 19h7a3 3 0 0 0 1.3-5.7" />
      </>
    ),
    company: (
      <>
        <path d="M4 21V5h8v16" />
        <path d="M12 9h8v12" />
        <path d="M7 9h2M7 13h2M7 17h2M15 13h2M15 17h2" />
      </>
    ),
    shield: (
      <>
        <path d="M12 3 20 6v5c0 5-3.4 8.5-8 10-4.6-1.5-8-5-8-10V6l8-3Z" />
        <path d="m9 12 2 2 4-4" />
      </>
    ),
    deploy: (
      <>
        <path d="M12 3v12" />
        <path d="m7 8 5-5 5 5" />
        <path d="M5 15v3a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-3" />
      </>
    ),
    calendar: (
      <>
        <rect x="3" y="5" width="18" height="16" rx="2" />
        <path d="M16 3v4M8 3v4M3 10h18" />
      </>
    ),
    card: (
      <>
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="M3 10h18M7 15h4" />
      </>
    ),
  };

  return <svg {...common}>{paths[name]}</svg>;
};

const reasons = [
  ["payroll", "Payroll Made Simple", "Run payroll with fewer manual steps, from salary setup and allowances to finalization, payslips, deductions, loans, and exports."],
  ["clock", "Attendance and Time Tracking", "Track time-in and time-out records, schedules, late minutes, overtime, undertime, breaks, and attendance summaries."],
  ["user", "Employee Self-Service", "Give employees access to their own portal for payslips, requests, attendance records, and time clock features when enabled."],
  ["approval", "Leave and Approval Management", "Manage leave requests, employee requests, approvals, and entitlement records with clear workflows and audit trails."],
  ["report", "Reports and Exports", "Generate useful reports for payroll, attendance, employees, leaves, wages, and loan monitoring, with exports for review and filing."],
  ["offline", "Offline-Ready Workflows", "Support selected attendance, employee, and request workflows during unstable internet connections."],
  ["company", "Multi-Company Support", "Support multiple companies, company switching, employee caps, and tenant-isolated data for enterprise use."],
  ["shield", "Secure Access Control", "Role-based access control helps users see and manage only the areas they are allowed to access."],
  ["deploy", "Ready for SaaS or Enterprise Deployment", "Run Waka Lite as a SaaS product with billing support or as a client-owned deployment with license management."],
];

const majorFeatures = [
  "Employee records and onboarding",
  "Attendance tracking and summaries",
  "Employee time clock",
  "Schedules and roster management",
  "Leave management",
  "Approval workflows",
  "Payroll generation and finalization",
  "Allowances, adjustments, and loans",
  "Payslips and payroll exports",
  "Employee self-service portal",
  "Reports for payroll, attendance, employees, leaves, and wages",
  "Role-based permissions",
  "Audit trail support",
  "Multi-company enterprise support",
  "Offline sync support for key workflows",
  "Production Docker deployment support",
];

const operations = [
  ["clock", "Track", "Capture attendance, schedule records, overtime, and undertime."],
  ["approval", "Approve", "Route leave and employee requests through clear approval flows."],
  ["payroll", "Process", "Prepare payroll drafts, adjustments, deductions, and payslips."],
  ["report", "Review", "Export payroll, attendance, employee, leave, wage, and loan reports."],
];

function WakaMockup() {
  return (
    <div className="wakaMockup" aria-label="Waka Lite payroll and attendance system preview">
      <div className="dashboardPanel">
        <div className="mockupTop">
          <span></span>
          <b>Waka Lite</b>
          <small>Payroll Cycle</small>
        </div>
        <div className="metricStrip">
          <div><small>Employees</small><strong>148</strong><em>Active</em></div>
          <div><small>Attendance</small><strong>96%</strong><em>Today</em></div>
          <div><small>Payroll</small><strong>Ready</strong><em>Draft</em></div>
        </div>
        <div className="payrollCard">
          <div>
            <span>Net Pay Run</span>
            <strong>PHP 1.82M</strong>
          </div>
          <button>Finalize</button>
        </div>
        <div className="timeline">
          {["Time Logs", "Adjustments", "Review", "Payslips"].map((item, index) => (
            <div key={item} className={index < 3 ? "done" : ""}>
              <i></i>
              <span>{item}</span>
            </div>
          ))}
        </div>
        <div className="attendanceChart">
          {[52, 74, 66, 88, 78, 94, 82].map((height, index) => <i key={index} style={{ height: `${height}%` }}></i>)}
        </div>
      </div>

      <div className="phonePanel">
        <div className="phoneHead">
          <img src={wakaLogo} alt="" />
          <span>Employee Portal</span>
        </div>
        <div className="profileDot"></div>
        <strong>Maria Santos</strong>
        <small>Time clock enabled</small>
        <div className="clockButton">Time In 08:02 AM</div>
        <div className="requestRows">
          <span>Leave request <b>Pending</b></span>
          <span>Payslip <b>Ready</b></span>
        </div>
      </div>

      <div className="approvalFloat">
        <Icon name="approval" size={24} />
        <span>3 approvals waiting</span>
      </div>
      <div className="secureFloat">
        <Icon name="shield" size={24} />
        <span>Role-based access</span>
      </div>
    </div>
  );
}

export default function WakaPayroll() {
  return (
    <main id="wakaPayrollPage">
      <section className="wakaHero">
        <div className="shell heroGrid">
          <div className="heroCopy">
            <span className="eyebrow">Waka Payroll</span>
            <div className="titleLockup">
              <img src={wakaLogo} alt="Waka Lite logo" />
              <h1>Waka Lite</h1>
            </div>
            <h2>Simple payroll, attendance, and employee management for growing teams.</h2>
            <p>
              Waka Lite helps businesses manage employees, track attendance,
              process payroll, handle approvals, and generate reports in one
              secure system.
            </p>
            <p className="heroStatement">
              Choose Waka Lite if you want a practical HR and payroll platform
              that is easy to deploy, easy to use, and built for day-to-day operations.
            </p>
            <div className="heroActions">
              <a className="button" href="#request-demo">Request a Demo <Icon name="arrow" size={17} /></a>
              <a className="button button--outline" href="#features">View Features</a>
            </div>
          </div>
          <WakaMockup />
        </div>
      </section>

      <section className="wakaSummary">
        <div className="shell summaryCard">
          <div>
            <span>Short Website Version</span>
            <p>
              Waka Lite is a simple payroll, attendance, and employee management
              system built for businesses that need a practical way to manage
              daily HR operations.
            </p>
            <p>
              With Waka Lite, teams can manage employees, track attendance, process
              payroll, approve requests, generate reports, and give employees
              access to self-service tools from one secure platform.
            </p>
          </div>
          <a href="#request-demo">Simplify HR operations <Icon name="arrow" size={16} /></a>
        </div>
      </section>

      <section className="whyChoose shell">
        <div className="sectionHeading">
          <span>Why Choose Waka Lite</span>
          <h2>Built for practical HR work, payroll accuracy, and daily team coordination.</h2>
        </div>
        <div className="reasonGrid">
          {reasons.map(([icon, title, text]) => (
            <article key={title}>
              <div><Icon name={icon} /></div>
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="featureSection" id="features">
        <div className="shell featureGrid">
          <div className="featureIntro">
            <span>Major Features</span>
            <h2>Everything teams need to run payroll, attendance, approvals, and reports.</h2>
            <p>
              Waka Lite keeps HR records, employee self-service, payroll preparation,
              time tracking, and reporting in one controlled workflow.
            </p>
            <div className="featureBadge">
              <Icon name="shield" />
              <span>Secure access, audit-ready workflows, and offline support for key operations.</span>
            </div>
          </div>
          <div className="featureList">
            {majorFeatures.map((item) => (
              <span key={item}><Icon name="check" size={16} />{item}</span>
            ))}
          </div>
        </div>
      </section>

      <section className="workflowBand">
        <div className="shell workflowGrid">
          {operations.map(([icon, title, text], index) => (
            <article key={title}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <Icon name={icon} />
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="platformFit shell">
        <div className="fitPanel">
          <div className="sectionHeading left">
            <span>Deployment Ready</span>
            <h2>Flexible for SaaS or enterprise use</h2>
          </div>
          <p>
            Waka Lite can support company switching, tenant-isolated data,
            employee caps, billing-ready SaaS use, or client-owned enterprise
            deployment with license management.
          </p>
        </div>
        <div className="fitPanel fitPanel--dark">
          <div className="sectionHeading left">
            <span>Daily Operations</span>
            <h2>Keep employee records and payroll work organized</h2>
          </div>
          <div className="benefitList">
            {[
              "Reduce manual payroll preparation",
              "Make attendance records easier to review",
              "Give employees direct self-service access",
              "Keep approvals traceable and controlled",
              "Export records for filing and reporting",
            ].map((item) => <span key={item}><Icon name="check" size={16} />{item}</span>)}
          </div>
        </div>
      </section>

      <section className="finalCta" id="request-demo">
        <div className="shell ctaInner">
          <div>
            <span>Call to Action</span>
            <h2>Start using Waka Lite to simplify payroll, attendance, and employee management.</h2>
            <p>Contact us today to request a demo or learn which setup is best for your team.</p>
          </div>
          <a className="button button--light" href="mailto:contact@brvtechnologysg.com">Contact Us Today <Icon name="arrow" size={16} /></a>
        </div>
      </section>
    </main>
  );
}
